/**
 * @generated SignedSource<<8e07914c5d8a6ba2c423c35f2e4b9a42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type parentsPostiesPageQuery$variables = Record<PropertyKey, never>;
export type parentsPostiesPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"newsFromScmpEducationQuery">;
};
export type parentsPostiesPageQuery = {
  response: parentsPostiesPageQuery$data;
  variables: parentsPostiesPageQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "parentsPostiesPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "newsFromScmpEducationQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "parentsPostiesPageQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "posties"
            }
          }
        ],
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"posties\"})"
      }
    ]
  },
  "params": {
    "cacheID": "730e42685e6bfa0e0ba2142f04425273",
    "id": null,
    "metadata": {},
    "name": "parentsPostiesPageQuery",
    "operationKind": "query",
    "text": "query parentsPostiesPageQuery {\n  ...newsFromScmpEducationQuery\n}\n\nfragment newsFromScmpEducationQuery on Query {\n  appConfig(filter: {entityId: \"posties\"}) {\n    json\n    id\n  }\n}\n"
  }
};

(node as any).hash = "7f36e700d27bc15973cdbfa1b09966dc";

export default node;
